import { useState } from 'react';
import type { CancelScheduledPaymentResponse, ScheduledPayment } from 'vopay';
import { api } from '@/services/api.config';
import { useDataFetchIndicator } from '..';

export default function useCancelScheduledTransaction() {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [cancelling, setCancelling] = useState(false);

  async function cancelScheduledTransaction(transaction: ScheduledPayment): Promise<CancelScheduledPaymentResponse> {
    try {
      setCancelling(true);
      setDataFetchingInfo(true, 'processing', 'fullScreen');

      const res = await api.postCancelScheduledPayment({ ScheduledPaymentsID: transaction.ID });

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (error) {
      console.error('Cancel scheduled transaction failed:', error);
      throw error;
    } finally {
      setCancelling(false);
      setDataFetchingInfo(false);
    }
  }

  return { cancelling, cancelScheduledTransaction };
}
